// removed by extract-text-webpack-plugin
module.exports = {"mercadoPagoLogo":"RIeow"};


//////////////////
// WEBPACK FOOTER
// ./components/icons/MercadoPagoIcon/MercadoPagoIcon.scss
// module id = 278
// module chunks = 0 1